// 260507nrai: Migrate must load in a separate module *after* jquery_globals — hoisted imports in one file still run migrate before body assigns window.jQuery.
import $ from './jquery_globals';
import '../vendor/jquery-migrate-3.5.2.min.js';
export { $ };
export default $;
